module.exports = __webpack_public_path__ + "static/blog_grid_2-09248d2fa1f391a37e577bff0d3a1fab.jpg";